module.exports = __webpack_public_path__ + "img/wf-works.5f8107d2.svg";